import { render, staticRenderFns } from "./AnswersModal.vue?vue&type=template&id=0322e4d6&scoped=true"
import script from "./AnswersModal.vue?vue&type=script&lang=js"
export * from "./AnswersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0322e4d6",
  null
  
)

export default component.exports